.componentAgentTrio {
  position: relative;
  width: 100%;
  height: 100%;

  .slot {
    position: absolute;
    width: 62%;
    height: 62%;
  }

  .left {
    left: -6%;
    top: 0;
    z-index: 1;
    opacity: .9;
  }

  .right {
    right: -6%;
    top: 0;
    z-index: 1;
    opacity: .9;
  }

  .front {
    left: 50%;
    bottom: -4%;
    width: 74%;
    height: 74%;
    z-index: 2;
    transform: translateX(-50%);
  }

  .face {
    width: 100%;
    height: 100%;
  }
}
